<app-dialog [showHeader]="false" [show]="show" [minWidthDefault]="false">
  <div class="warning-dialog-container">
    <div class="header">
      {{header}}
    </div>
    <div class="description">
      {{description}}
    </div>

    <div class="controls">
      <app-button customClasses="px-4"
                  subStyle="transparent"
                  [minWidth]="0"
                  [text]="cancelBtnText"
                  class="cancel"
                  (clicked)="cancel.next()"
      >
      </app-button>

      <app-button styleClass="settings"
                  [minWidth]="0"
                  subStyle="red"
                  [text]="acceptBtnText"
                  class="accept"
                  (clicked)="next.next()"
      >
      </app-button>
    </div>
  </div>
</app-dialog>
